import { useRef, useState } from "react"
import "./styles/Backoffice.css"
import { Toaster, toast } from "react-hot-toast"
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { newsActions } from "../service";
import { RoundedDialog } from "./styles/RoundedDialog";
import { Box, Grid, IconButton } from '@mui/material';


function NewsBack(props) {
    const [openF, setOpenF] = useState(false)
    const [novedad, setNovedad] = useState()
    const [modal, setModal] = useState(false);
    const formNews = useRef()
    const updateForm = useRef()

    const sendNews = (e) => {
        e.preventDefault()
        formNews.current.focus()
        let data = new FormData(formNews.current)
        newsActions.save(data)
            .then(res => {
                res.success ? (
                    toast.success("Cargado correcatmente", {
                        style: {
                            backgroundClip: "#f09236",
                            color: "black",
                            fontWeight: "bold"
                        }
                    })
                ) : (
                    toast.error("Error al cargar los datos vuelve a intentar mas tarde", {
                        style: {
                            backgroundColor: "#f09236",
                            color: "black",
                            fontWeight: "bold"
                        }
                    })
                )
                res.success && formNews.current.reset()
                let newArray = props.news
                newArray.push(res.payload)
                props.setNews(newArray)
                setOpenF(!openF)
            })
    }

    function removeItem(id) {
        newsActions.removeNew(id)
            .then(res => {
                toast.success("Eliminado correctamente", {
                    style: {
                        backgroundClip: "#f09236",
                        color: "white",
                        fontWeight: "bold"
                    }
                })
                props.setNews(props.news.filter(novedad => novedad._id !== id))
            })
    }

    const handleClick = (novedad) => {
        setNovedad(novedad)
        setModal(!modal)
    }
    const updateNews = (e) => {
        e.preventDefault()
        updateForm.current.focus()
        let data = new FormData(updateForm.current)
        newsActions.update(data)
            .then(res => {
                res.success && toast.success("Actualizado correcatmente", {
                    style: {
                        backgroundClip: "#f09236",
                        color: "black",
                        fontWeight: "bold"
                    }
                })
                let newArray = [...props.news]
                let index = props.news.map(n => n._id).indexOf(res.payload._id)
                // let a = index.indexOf(res.payload._id)
                newArray.splice(index, 1, { ...res.payload })
                props.setNews(newArray)
                setModal(!modal)

            })
    }

    return (
        <>
            <Toaster
                position="bottom-right" />
            <h2>NEWS</h2>
            <ul className="ulContainer">
                {props.news?.map(el => {
                    return (
                        <li key={el._id} >
                            {el.title.es}
                            <div>
                                <EditIcon onClick={() => handleClick(el)} className="btnModify" />
                                <DeleteIcon className="btnModify" onClick={() => removeItem(el._id)} />
                            </div>
                        </li>
                    )
                })}
            </ul>
            <button onClick={() => setOpenF(!openF)}>Cargar novedad</button>
            <form ref={formNews} onSubmit={(e) => sendNews(e)} className={openF ? "formBack" : "formBack none"}>
                <button type="button" className="close" style={{ color: "black" }} onClick={() => setOpenF(!openF)}>+</button>
                <h2>Caragar Novedades</h2>
                <div className="fielsetContainer">

                    <fieldset style={{ flexDirection: "column", display: "flex" }}>
                        <legend>TÍTULO</legend>
                        <label htmlFor="titleES">Título en español</label>
                        <input required name="titleES" className="input" id="titleES" placeholder="Ttulo español" type="text" />
                        <label htmlFor="titleEN">Título en inglés</label>
                        <input required name="titleEN" className="input" id="titleEN" placeholder="Titulo inglés" type="text" />
                    </fieldset>
                    <fieldset style={{ flexDirection: "column", display: "flex" }}>
                        <legend>Descripción</legend>
                        <label htmlFor="descriptionES">Descripción en español</label>
                        <textarea required name="descriptionES" className="input" id="descriptionES" placeholder="Descripcion español" type="text" />
                        <label htmlFor="descriptionEN">Descripción en inglés</label>
                        <textarea required name="descriptionEN" className="input" id="descriptionEN" placeholder="Descripcion inglés" type="text" />
                    </fieldset>
                </div>
                <div className="fielsetContainer">
                    <fieldset style={{ flexDirection: "column", display: "flex" }}>
                        <legend>Resumen</legend>
                        <label htmlFor="resumenES">Resumen en español</label>
                        <textarea required name="resumenES" className="input" id="resumenES" placeholder="Resumen español" type="text" />
                        <label htmlFor="resumenEN">Resumen en inglés</label>
                        <textarea required name="resumenEN" className="input" id="resumenEN" placeholder="Resumen inglés" type="text" />
                    </fieldset>
                    <fieldset style={{ flexDirection: "column", display: "flex" }}>
                        <legend>Tags/Categoría </legend>
                        <label htmlFor="tags">Tags # <span style={{ fontSize: "0.8rem" }}>( Ingrese los tags sin espacios separadas por una "," )</span></label>
                        <textarea required name="tags" className="input" id="tags" placeholder="#Tags" type="text" />
                    </fieldset>
                </div>
                <div className="fielsetContainer">
                    <fieldset style={{ flexDirection: "column", display: "flex", width: "49%" }}>
                        <legend>Imagen</legend>
                        <label htmlFor="imgUrl">URL de imagen</label>
                        <input required name="imgUrl" className="input" id="imgUrl" placeholder="URL" type="text" />
                    </fieldset>
                </div>
                <button className="btnSend" type="submit">Cargar</button>
            </form>
            {modal && (
                <RoundedDialog
                    open={true}
                    fullWidth
                    maxWidth='lg'
                    style={{ border: '1px solid black' }}
                    className="modalEdit"
                >
                    <button type="button" className="close" style={{ color: "black" }} onClick={() => setModal(!modal)}>+</button>
                    <Box sx={{ padding: '0', backgroundColor: 'white', height: "100vh" }}>
                        <form ref={updateForm} onSubmit={(e) => updateNews(e)} className="formBack">
                            <h2>Actualizar Novedad</h2>
                            <div className="fielsetContainer">

                                <fieldset style={{ flexDirection: "column", display: "flex" }}>
                                    <legend>TÍTULO</legend>
                                    <label htmlFor="titleES">Título en español</label>
                                    <input defaultValue={novedad.title.es} required name="titleES" className="input" id="titleES" placeholder="Ttulo español" type="text" />
                                    <label htmlFor="titleEN">Título en inglés</label>
                                    <input defaultValue={novedad.title.en} required name="titleEN" className="input" id="titleEN" placeholder="Titulo inglés" type="text" />
                                </fieldset>
                                <fieldset style={{ flexDirection: "column", display: "flex" }}>
                                    <legend>Descripción</legend>
                                    <label htmlFor="descriptionES">Descripción en español</label>
                                    <textarea defaultValue={novedad.description.es} required name="descriptionES" className="input" id="descriptionES" placeholder="Descripcion español" type="text" />
                                    <label htmlFor="descriptionEN">Descripción en inglés</label>
                                    <textarea defaultValue={novedad.description.en} required name="descriptionEN" className="input" id="descriptionEN" placeholder="Descripcion inglés" type="text" />
                                </fieldset>
                            </div>
                            <div className="fielsetContainer">
                                <fieldset style={{ flexDirection: "column", display: "flex" }}>
                                    <legend>Resumen</legend>
                                    <label htmlFor="resumenES">Resumen en español</label>
                                    <textarea defaultValue={novedad.abstract.es} required name="resumenES" className="input" id="resumenES" placeholder="Resumen español" type="text" />
                                    <label htmlFor="resumenEN">Resumen en inglés</label>
                                    <textarea defaultValue={novedad.abstract.en} required name="resumenEN" className="input" id="resumenEN" placeholder="Resumen inglés" type="text" />
                                </fieldset>
                                <fieldset style={{ flexDirection: "column", display: "flex" }}>
                                    <legend>Tags/Categoría </legend>
                                    <label htmlFor="tags">Tags # <span style={{ fontSize: "0.8rem" }}>( Ingrese los tags sin espacios separadas por una "," )</span></label>
                                    <textarea defaultValue={novedad.tags.join(",")} required name="tags" className="input" id="tags" placeholder="#Tags" type="text" />
                                </fieldset>
                            </div>
                            <div className="fielsetContainer">
                                <fieldset style={{ flexDirection: "column", display: "flex", width: "49%" }}>
                                    <legend>Imagen</legend>
                                    <label htmlFor="imgUrl">URL de imagen</label>
                                    <input defaultValue={novedad.imgUrl} required name="imgUrl" className="input" id="imgUrl" placeholder="URL" type="text" />
                                </fieldset>
                                <input defaultValue={novedad._id} required name="id" className="input" id="id" type="hidden" />
                            </div>
                            <button className="btnSend" type="submit">Actualizar</button>
                        </form>
                    </Box>
                </RoundedDialog>
            )}
        </>

    )
}



export default NewsBack


